import React from "react";
import { useCheckoutStateSelector as useSelector } from "@capone/checkout";
import { Box } from "@material-ui/core";

import {
  ExperiencesAdditionalDetailsSelectors,
  PickupPointOption,
} from "../../../../../checkout";
import styles from "./styles.module.scss";

export const AdditionalDetailsCompleted = () => {
  const {
    selectedPickupPoint,
    hotelSelection,
    hotelName,
    address,
    city,
    zipCode,
  } = useSelector(ExperiencesAdditionalDetailsSelectors.getPickupPointStates);
  const isPickupIncluded = useSelector(
    ExperiencesAdditionalDetailsSelectors.getIsPickupIncluded
  );
  const selectedLangGuide = useSelector(
    ExperiencesAdditionalDetailsSelectors.getSelectedLangGuide
  );
  const specialRequirement = useSelector(
    ExperiencesAdditionalDetailsSelectors.getSpecialRequirement
  );

  const renderPickupPoint = () => {
    let pickupPoint;

    switch (selectedPickupPoint) {
      case PickupPointOption.SelectPickup: {
        if (
          hotelSelection?.experienceLocation?.name === "I don't see my hotel"
        ) {
          pickupPoint = [hotelName, address, city, zipCode].join(", ");
        } else {
          pickupPoint = `${hotelSelection?.experienceLocation?.name}, ${hotelSelection?.experienceLocation?.address}`;
        }
        break;
      }
      case PickupPointOption.PickupLater:
        pickupPoint = "Arrange pickup later";
        break;
      case PickupPointOption.NoPickup:
        pickupPoint = isPickupIncluded
          ? "Pick-up not required"
          : "Meet tour operator at meeting point";
        break;
      default:
        pickupPoint = "";
    }

    return (
      <Box>
        <span className={styles["field-label"]}>Pickup: </span>
        {pickupPoint}
      </Box>
    );
  };

  return (
    <Box className={styles["additional-details-completed-container"]}>
      {selectedPickupPoint && renderPickupPoint()}
      {selectedLangGuide && (
        <Box>
          <span className={styles["field-label"]}>Language: </span>
          {selectedLangGuide.languageDisplayName}
        </Box>
      )}
      {specialRequirement && (
        <Box>
          <span className={styles["field-label"]}>Special requirements: </span>
          {specialRequirement}
        </Box>
      )}
    </Box>
  );
};
